export default (value) => {
  let result
  if (typeof value === 'string' || value instanceof String) {
    result = value.toUpperCase()
  } else {
    result = value.toString().toUpperCase()
  }

  return result
}



// WEBPACK FOOTER //
// ./src/filters/toUpperCase.js